import React from 'react';

interface ICloseIconProps {
  style?: any;
}

export const CloseIcon:React.FC<ICloseIconProps> = (props: ICloseIconProps) => {
  return (
    <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" style={props.style}>
    <title/>
    <desc/>
    <g>
      <title>background</title>
      <rect fill="none" id="canvas_background" height="402" width="582" y="-1" x="-1"/>
    </g>
    <g>
      <title>Layer 1</title>
      <path fill="#122442" id="Shape" d="m14,1.4l-1.4,-1.4l-5.6,5.6l-5.6,-5.6l-1.4,1.4l5.6,5.6l-5.6,5.6l1.4,1.4l5.6,-5.6l5.6,5.6l1.4,-1.4l-5.6,-5.6l5.6,-5.6z"/>
    </g>
    </svg>
  )
}